module.exports = __webpack_public_path__ + "img/clogo.7a8641c9.png";